import React, { FunctionComponent } from 'react'
import { FormattedMessage } from 'react-intl'
import { ImageSourcePropType } from 'react-native'

import styled, { useTheme } from 'styled-components/native'

import wellnessCheckInResultsFooterSpecialNeed from '../../assets/WellnessCheckInResultsFooterSpecialNeed.png'
import { BodyText } from '../../atoms/bodyText/BodyText'
import { Image } from '../../atoms/image/Image'
import { SecondaryButton } from '../../atoms/secondaryButton/SecondaryButton'
import { Title } from '../../atoms/title/Title'
import { BodyTextSize, TitleSize } from '../../styles/typeStyles'
import { ThemeType } from '../../utils/themes/ThemeProvider'
import { tID } from '../../utils/utils'

export interface WellnessCheckInResultsSocialNeedsProps {
  onPress: () => void
}

const SocialNeedsContainer = styled.View<{ theme: ThemeType }>(({ theme }) => ({
  padding: theme.breakpoints.isMobileSized
    ? `${theme.spacing['64px']} ${theme.spacing['16px']}`
    : `${theme.spacing['64px']} 0`,
  flexDirection: theme.breakpoints.isMobileSized ? 'column' : 'row',
  margin: 'auto',
  justifyContent: 'center',
  alignItems: 'center',
}))

const TextContainer = styled.View<{ theme: ThemeType }>(({ theme }) => ({
  padding: theme.breakpoints.isMobileSized ? `0 ${theme.spacing['16px']}` : `0 ${theme.spacing['40px']}`,
  maxWidth: '684px',
  flex: theme.breakpoints.isMobileSized ? 'auto' : 1,
}))

const TitleTextContainer = styled.View<{ theme: ThemeType }>(({ theme }) => ({
  marginBottom: theme.spacing['4px'],
  ...(theme.breakpoints.isMobileSized && { marginTop: theme.spacing['16px'] }),
}))

const DescriptionTextContainer = styled.View<{ theme: ThemeType }>(({ theme }) => ({
  marginBottom: theme.breakpoints.isMobileSized ? theme.spacing['16px'] : 0,
}))

const ImageContainer = styled(Image)<{ theme: ThemeType }>({
  width: '128px',
  height: '128px',
})

const LearnMoreButton = styled(SecondaryButton)(() => ({
  alignSelf: 'center',
}))

export const WellnessCheckInResultsSocialNeeds: FunctionComponent<WellnessCheckInResultsSocialNeedsProps> = ({
  onPress,
}) => {
  const {
    breakpoints: { isMobileSized },
    colors,
  } = useTheme() as ThemeType

  return (
    <SocialNeedsContainer testID={tID(`WellnessCheckInResultsSocialNeeds`)}>
      <ImageContainer
        source={wellnessCheckInResultsFooterSpecialNeed as ImageSourcePropType}
        contentFit='cover'
        accessibilityIgnoresInvertColors
      />
      <TextContainer>
        <TitleTextContainer>
          <Title
            text={
              <FormattedMessage
                defaultMessage='Looking for support with other needs?'
                description='Wellness check in results footer social need title'
              />
            }
            size={TitleSize.MEDIUM}
            color={colors.textSecondary}
            textAlign={isMobileSized ? 'center' : 'left'}
          />
        </TitleTextContainer>
        <DescriptionTextContainer>
          <BodyText
            text={
              <FormattedMessage
                defaultMessage='Our Resource Coordinators can support your core needs, such as access to food, housing, transportation, social belonging, and more.'
                description='Wellness check in results footer social need description'
              />
            }
            size={BodyTextSize.DEFAULT}
            color={colors.textSecondary}
            textAlign={isMobileSized ? 'center' : 'left'}
          />
        </DescriptionTextContainer>
      </TextContainer>
      <LearnMoreButton
        onPress={onPress}
        text={
          <FormattedMessage
            defaultMessage='Learn more'
            description='Wellness check in results footer social need button text'
          />
        }
        testID={tID('WellnessCheckInResultsFooterSocialNeedButton')}
      />
    </SocialNeedsContainer>
  )
}
